/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { LiveNetworkModel } from '../models/live-network-model';
import { NodeDetails } from '../models/node-details';
import { MapNodes } from '../models/map-nodes';
import { ValveMeter } from '../models/valve-meter';
import { WeatherStation } from '../models/weather-station';
import { Awrf } from '../models/awrf';
@Injectable({
  providedIn: 'root',
})
class EucsLnmService extends __BaseService {
  static readonly EucsLnmGetLatestPath = '/api/eucs/EucsLnm/GetLatest';
  static readonly EucsLnmGetValveMeterDetailsPath = '/api/eucs/EucsLnm/GetValveMeterDetails';
  static readonly EucsLnmGetMapNodesPath = '/api/eucs/EucsLnm/GetMapNodes';
  static readonly EucsLnmGetLatestValveMetersPath = '/api/eucs/EucsLnm/GetLatestValveMeters';
  static readonly EucsLnmGetWeatherStationsPath = '/api/eucs/EucsLnm/GetWeatherStations';
  static readonly EucsLnmGetAwrfPath = '/api/eucs/EucsLnm/GetAwrf';
  static readonly EucsLnmUpdatePath = '/api/eucs/EucsLnm/Update';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  EucsLnmGetLatestResponse(): __Observable<__StrictHttpResponse<LiveNetworkModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/eucs/EucsLnm/GetLatest`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LiveNetworkModel>;
      })
    );
  }  EucsLnmGetLatest(): __Observable<LiveNetworkModel> {
    return this.EucsLnmGetLatestResponse().pipe(
      __map(_r => _r.body as LiveNetworkModel)
    );
  }

  /**
   * @param excludeAssignedValveMeters undefined
   */
  EucsLnmGetValveMeterDetailsResponse(excludeAssignedValveMeters?: boolean): __Observable<__StrictHttpResponse<Array<NodeDetails>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (excludeAssignedValveMeters != null) __params = __params.set('excludeAssignedValveMeters', excludeAssignedValveMeters.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/eucs/EucsLnm/GetValveMeterDetails`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<NodeDetails>>;
      })
    );
  }
  /**
   * @param excludeAssignedValveMeters undefined
   */
  EucsLnmGetValveMeterDetails(excludeAssignedValveMeters?: boolean): __Observable<Array<NodeDetails>> {
    return this.EucsLnmGetValveMeterDetailsResponse(excludeAssignedValveMeters).pipe(
      __map(_r => _r.body as Array<NodeDetails>)
    );
  }
  EucsLnmGetMapNodesResponse(): __Observable<__StrictHttpResponse<MapNodes>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/eucs/EucsLnm/GetMapNodes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<MapNodes>;
      })
    );
  }  EucsLnmGetMapNodes(): __Observable<MapNodes> {
    return this.EucsLnmGetMapNodesResponse().pipe(
      __map(_r => _r.body as MapNodes)
    );
  }
  EucsLnmGetLatestValveMetersResponse(): __Observable<__StrictHttpResponse<Array<ValveMeter>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/eucs/EucsLnm/GetLatestValveMeters`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ValveMeter>>;
      })
    );
  }  EucsLnmGetLatestValveMeters(): __Observable<Array<ValveMeter>> {
    return this.EucsLnmGetLatestValveMetersResponse().pipe(
      __map(_r => _r.body as Array<ValveMeter>)
    );
  }
  EucsLnmGetWeatherStationsResponse(): __Observable<__StrictHttpResponse<Array<WeatherStation>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/eucs/EucsLnm/GetWeatherStations`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<WeatherStation>>;
      })
    );
  }  EucsLnmGetWeatherStations(): __Observable<Array<WeatherStation>> {
    return this.EucsLnmGetWeatherStationsResponse().pipe(
      __map(_r => _r.body as Array<WeatherStation>)
    );
  }
  EucsLnmGetAwrfResponse(): __Observable<__StrictHttpResponse<Awrf>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/eucs/EucsLnm/GetAwrf`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Awrf>;
      })
    );
  }  EucsLnmGetAwrf(): __Observable<Awrf> {
    return this.EucsLnmGetAwrfResponse().pipe(
      __map(_r => _r.body as Awrf)
    );
  }

  /**
   * @param liveNetworkModel undefined
   */
  EucsLnmUpdateResponse(liveNetworkModel: LiveNetworkModel): __Observable<__StrictHttpResponse<LiveNetworkModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = liveNetworkModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/eucs/EucsLnm/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LiveNetworkModel>;
      })
    );
  }
  /**
   * @param liveNetworkModel undefined
   */
  EucsLnmUpdate(liveNetworkModel: LiveNetworkModel): __Observable<LiveNetworkModel> {
    return this.EucsLnmUpdateResponse(liveNetworkModel).pipe(
      __map(_r => _r.body as LiveNetworkModel)
    );
  }
}

module EucsLnmService {
}

export { EucsLnmService }
